const STORAGE_KEYS = {
      selected_language: "selected_language",
      auth_details: "auth_details",
      tenant_db: "tenant-db"
    };
    
    export default STORAGE_KEYS;